import { useEffect, useState } from "react";
import { collection, getDocs, doc, getDoc, query, where } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig"; // Ajuste o caminho para seu projeto

export const useSubscription = (user) => {
  const [plans, setPlans] = useState([]);
  const [subscription, setSubscription] = useState(null);

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const plansSnapshot = await getDocs(collection(db, "plans"));
        const fetchedPlans = plansSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setPlans(fetchedPlans);
      } catch (error) {
        console.error("❌ Erro ao buscar planos:", error);
      }
    };

    const fetchSubscription = async () => {
      if (!user?.uid) return;

      try {
        console.log("🔍 Buscando assinatura para userId:", user.uid);

        // 🔹 Criando a referência correta para comparar
        const userRef = doc(db, "users", user.uid);

        const subscriptionQuery = query(
          collection(db, "subscriptions"),
          where("userId", "==", userRef) // 🔥 Comparação correta com referência
        );

        const subscriptionSnapshot = await getDocs(subscriptionQuery);

        console.log("📌 Resultado da busca de assinatura:", subscriptionSnapshot.docs.length);

        if (!subscriptionSnapshot.empty) {
          const subscriptionDoc = subscriptionSnapshot.docs[0];
          const subscriptionData = subscriptionDoc.data();

          console.log("✅ Assinatura encontrada:", subscriptionData);

          if (subscriptionData.planId instanceof Object && subscriptionData.planId.id) {
            // 🔥 Buscando o plano corretamente a partir da referência
            const planDoc = await getDoc(subscriptionData.planId);
            if (planDoc.exists()) {
              console.log("✅ Plano encontrado:", planDoc.data());

              setSubscription({
                id: subscriptionDoc.id,
                ...subscriptionData,
                plan: { id: planDoc.id, ...planDoc.data() },
              });
            } else {
              console.warn("⚠️ Plano não encontrado no Firestore:", subscriptionData.planId.id);
            }
          } else {
            console.warn("⚠️ `planId` não é uma referência válida:", subscriptionData.planId);
            setSubscription(subscriptionData);
          }
        } else {
          console.log("⚠️ Nenhuma assinatura encontrada para este usuário.");
        }
      } catch (error) {
        console.error("❌ Erro ao buscar assinatura:", error);
      }
    };

    fetchPlans();
    fetchSubscription();
  }, [user]);

  return { plans, subscription, setSubscription };
};
